import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["qrCodeSrc", "appStoreCampaign"];
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import CUIAppStoreButton from 'connect-dot-com-ui-components/Components/CUIAppStoreButton/CUIAppStoreButton';
import CUIImage from 'connect-dot-com-ui-components/Components/CUIImage/CUIImage';
import CUILink from 'connect-dot-com-ui-components/Components/CUILink/CUILink';
import { CUIHStack, CUIVStack } from 'connect-dot-com-ui-components/Components/CUIStack/CUIStack';
import CUIText from 'connect-dot-com-ui-components/Components/CUIText/CUIText';
import useNotifications from 'connect-dot-com-ui-components/hooks/useNotifications';
import Raven from 'raven-js';
import { Form } from 'react-final-form';
import { trackInteraction } from '../../utils/usageTracker';
import FFSingleInputForm from '../Forms/FFSingleInputForm';
import { composeValidators, required, validEmail } from '../Forms/validators';
import { CUIDivider } from 'connect-dot-com-ui-components/Components/CUIDivider/CUIDivider';
import { CUIHeading } from 'connect-dot-com-ui-components/Components/CUIHeading/CUIHeading';
import FormattedMessage from 'I18n/components/FormattedMessage';
import CUIBox from 'connect-dot-com-ui-components/Components/CUIBox/CUIBox';
import { useState } from 'react';
import { addUserToAndroidWaitlist } from '../../api/formsApi';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AndroidModalPanel = () => {
  const [addingUserToList, setAddingUserToList] = useState(false);
  const {
    notifyError,
    notifySuccess
  } = useNotifications();
  const onSubmit = async ({
    emailAddress
  }) => {
    setAddingUserToList(true);
    try {
      await addUserToAndroidWaitlist(emailAddress);
      trackInteraction('android waitlist form submitted');
      notifySuccess(I18n.text('app.Banners.downloadApp.androidWaitingListForm.successTitle'), I18n.text('app.Banners.downloadApp.androidWaitingListForm.successDescription'));
    } catch (e) {
      notifyError(I18n.text('app.Banners.downloadApp.androidWaitingListForm.errorTitle'), I18n.text('app.Banners.downloadApp.androidWaitingListForm.errorDescription'));
      Raven.captureException(e);
    } finally {
      setAddingUserToList(false);
    }
  };
  return /*#__PURE__*/_jsx(CUIBox, {
    flex: 1,
    children: /*#__PURE__*/_jsx(Form, {
      onSubmit: onSubmit,
      render: ({
        handleSubmit,
        submitSucceeded
      }) => /*#__PURE__*/_jsx("form", {
        onSubmit: e => void handleSubmit(e),
        children: /*#__PURE__*/_jsxs(CUIVStack, {
          gap: 5,
          children: [/*#__PURE__*/_jsx(CUIHeading, {
            size: "md",
            as: "h4",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.Banners.downloadApp.modal.androidHeading"
            })
          }), /*#__PURE__*/_jsx(CUIText, {
            children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "app.Banners.downloadApp.modal.androidDescription3",
              elements: {
                Link: CUILink
              }
            })
          }), !submitSucceeded && /*#__PURE__*/_jsx(CUIBox, {
            mt: 8,
            w: "full",
            children: /*#__PURE__*/_jsx(FFSingleInputForm, {
              name: "emailAddress",
              inputProps: {
                type: 'email'
              },
              validate: composeValidators(required, validEmail),
              buttonProps: {
                type: 'submit',
                isLoading: addingUserToList
              },
              placeholder: I18n.text('app.Banners.downloadApp.androidWaitingListForm.emailPlaceholder'),
              buttonText: I18n.text('app.Banners.downloadApp.androidWaitingListForm.notifyMeCTA'),
              size: "md"
            })
          })]
        })
      })
    })
  });
};
const IOSModalPanel = ({
  qrCodeSrc,
  appStoreCampaign
}) => {
  return /*#__PURE__*/_jsxs(CUIVStack, {
    gap: 5,
    flex: 1,
    children: [/*#__PURE__*/_jsx(CUIHeading, {
      size: "md",
      as: "h4",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.Banners.downloadApp.modal.iosHeading"
      })
    }), /*#__PURE__*/_jsx(CUIText, {
      textAlign: "center",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "app.Banners.downloadApp.modal.iosDescription"
      })
    }), /*#__PURE__*/_jsx(CUIImage, {
      src: qrCodeSrc,
      alt: "",
      width: "200px"
    }), /*#__PURE__*/_jsx(CUIAppStoreButton, {
      color: "white",
      campaign: appStoreCampaign
    })]
  });
};
export default function DownloadAppContent(_ref) {
  let {
      qrCodeSrc,
      appStoreCampaign
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(CUIHStack, Object.assign({}, rest, {
    children: /*#__PURE__*/_jsxs(CUIVStack, {
      gap: 5,
      flex: 1,
      divider: /*#__PURE__*/_jsx(CUIDivider, {
        w: "full",
        h: "1px"
      }),
      children: [/*#__PURE__*/_jsx(CUIText, {
        textAlign: "center",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "app.Banners.downloadApp.modal.pitchContent"
        })
      }), /*#__PURE__*/_jsxs(CUIHStack, {
        divider: /*#__PURE__*/_jsx(CUIDivider, {
          orientation: "vertical",
          minHeight: "340px"
        }),
        alignItems: "stretch",
        gap: 5,
        children: [/*#__PURE__*/_jsx(IOSModalPanel, {
          qrCodeSrc: qrCodeSrc,
          appStoreCampaign: appStoreCampaign
        }), /*#__PURE__*/_jsx(AndroidModalPanel, {})]
      })]
    })
  }));
}